import ReactGA from 'react-ga'

const CreateNewApp = () => {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Create New App',
  })
}

export default CreateNewApp
